export enum OrderStatus {
  PENDING = 'Pending',
  ACCEPTED = 'Accepted',
  PAID = 'Paid',
  IN_PREPARATION = 'In Preparation',
  READY_FOR_PICKUP = 'Ready for Pickup',
  ACCEPTED_BY_COURIER = 'Accepted by Courier',
  ON_THE_WAY = 'On the way',
  DELIVERED = 'Delivered',
  CANCELLED = 'Cancelled',
}
